import { render, staticRenderFns } from "./FilterMultiChip.vue?vue&type=template&id=2dc2efc3"
import script from "./FilterMultiChip.vue?vue&type=script&lang=js"
export * from "./FilterMultiChip.vue?vue&type=script&lang=js"
import style0 from "./FilterMultiChip.vue?vue&type=style&index=0&id=2dc2efc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports